import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const ReasonDialog = ({ open, onClose, title, description, confirmLabel = "Confirm", danger, onConfirm }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => { setBusy(true); try { await onConfirm(reason); setReason(""); onClose(); } finally { setBusy(false); } };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="reason-dialog">
        <DialogHeader><DialogTitle>{title}</DialogTitle>{description && <DialogDescription>{description}</DialogDescription>}</DialogHeader>
        <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (recorded in the audit log)" className="bg-white" data-testid="reason-input" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="reason-cancel">Cancel</Button>
          <Button variant={danger ? "destructive" : "default"} disabled={busy || reason.trim().length < 3} onClick={go} data-testid="reason-confirm">{confirmLabel}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
